import { createAsyncThunk } from '@reduxjs/toolkit';
import { getFirstFeatureData } from '../api/firstFeature.api';

export const getFirstFeature = createAsyncThunk(
  'FirstFeature/getFirstFeature',
  async (params: any | undefined, thunkAPI) => {
    try {
      // Default parameters for fetching first feature
      const defaultParams: any = {
        size: 10,
      };
      // Call API to get first feature data
      const response = await getFirstFeatureData(params ?? defaultParams);
      return response;
    } catch (e) {
      // Return error if API call fails
      return thunkAPI.rejectWithValue(e);
    }
  }
);